// extracted by mini-css-extract-plugin
export default {"contentInner":"styles-module__WaY56","modal":"styles-module__iDV0Q","ownerButton":"styles-module__ATE4m"};